import { render } from "./Actualizaciones.vue?vue&type=template&id=f7881ccc&scoped=true"
import script from "./Actualizaciones.vue?vue&type=script&lang=js"
export * from "./Actualizaciones.vue?vue&type=script&lang=js"

import "./Actualizaciones.vue?vue&type=style&index=0&id=f7881ccc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7881ccc"]])

export default __exports__